<div class="row">
  <div class="col-md-3">
    <div class="label form-label">{{attribute.name}} {{ attribute.required ? '*' : ''}}</div>
    <div class="description" *ngIf="attribute.description">{{attribute.description}}</div>
  </div>
  <div class="col-md-9">
    <mat-form-field class="full" appearance="outline" color="warn">
      <mat-label>Từ Ngày</mat-label>
      <input matInput [ngxMatDatetimePicker]="picker" placeholder="Choose a date" [formControl]="startDateControl">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <ngx-mat-datetime-picker #picker [showSeconds]="false">
      </ngx-mat-datetime-picker>
      <mat-error *ngIf="startDateControl.invalid && startDateControl.errors?.key == 'start_date_greater_than_end_date'">Ngày giờ bắt đầu lớn hơn ngày giờ kết thúc</mat-error>
      <mat-error *ngIf="startDateControl.invalid && startDateControl.errors?.required">Ngày giờ bắt đầu rỗng</mat-error>
    </mat-form-field>
    <mat-form-field class="full" appearance="outline" color="warn">
      <mat-label>Đến Ngày</mat-label>
      <input matInput [ngxMatDatetimePicker]="endPicker" placeholder="Choose a date" [formControl]="endDateControl">
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <ngx-mat-datetime-picker #endPicker [showSeconds]="false">
      </ngx-mat-datetime-picker>
      <mat-error *ngIf="endDateControl.invalid && endDateControl.errors?.key == 'end_date_less_than_start_date'">Ngày giờ kết thúc nhỏ hơn ngày giờ bắt đầu</mat-error>
      <mat-error *ngIf="endDateControl.invalid && endDateControl.errors?.required">Ngày giờ kết thúc rỗng</mat-error>
    </mat-form-field>
  </div>
</div>
